const { routerBasename, settings, defaultCountry, isAdmin, ajaxUrl, isFlatsomeTheme } = flatsomeCheckoutData;
const $ = window.jQuery;

jQuery(($) => {

  const main = {

    epsilonLabExperiments: {
      isVariationActive: function (experimentId, variationId) {
        if (typeof window.epsilonLab === "undefined" || !window.epsilonLab.getActiveExperiments) {
          return false;
        }

        const actives = window.epsilonLab.getActiveExperiments();

        return Boolean(actives) && Number(actives[experimentId]) === variationId;
      },

      // PB-1835: browser Autofill + Google Autocomplete in the address field.
      googleAddressAutofill: function () {
        return this.isVariationActive(388, 725);
      },
    },

    common: function () {

      if (isFlatsomeTheme !== "1" && typeof FloatLabels !== "undefined") {
        new FloatLabels(".fc-checkout-enabled", {
          prioritize: "placeholder",
          exclude: ".qty",
          /**
           * Function runs immediately after an element has been transformed.
           */
          customEvent: function (el) {
            // wc_address_i18n_params is required to continue, ensure the object exists
            if (typeof wc_address_i18n_params === "undefined") {
              return;
            }

            let field = el.id !== "undefined" ? document.getElementById(el.id + "_field") : null;

            // Insert label required abbreviation if not exist yet.
            if (field !== null && field.classList.contains("validate-required")) {
              if (field.querySelector("label .required") === null) {
                field.querySelector("label").insertAdjacentHTML("beforeend", "&nbsp;<abbr class=\"required\" title=\"" + wc_address_i18n_params.i18n_required_text + "\">*</abbr>");
              }
            }
          },
        });
      }
    },

    pages: {

      checkout: {

        init: function () {
          const $body = $(document.body);

          const slideDuration = 280;

          const $form = $("form.checkout"),
            $address = $(".fc-checkout-steps__item#address");

          const shippingToBillingMapping = {
            shipping_country: "billing_country",
            shipping_first_name: "billing_first_name",
            shipping_last_name: "billing_last_name",
            shipping_company: "billing_company",
            shipping_address_1: "billing_address_1",
            shipping_postcode: "billing_postcode",
            shipping_city: "billing_city",
            fc_shipping_vat_id: "fc_billing_vat_id",
          };

          function syncShippingPhone() {
            $("#shipping_phone").val($("#billing_phone").val());
          }

          $form.on("input change", "#billing_phone", syncShippingPhone);

          syncShippingPhone();

          $form.on("input change", "input, select, textarea", function () {
            const data = {};

            $form.find("input, select, textarea")
              .not(":button, :submit, :reset, [type='hidden']")
              .each(function () {
                const $field = $(this);
                const name = $field.attr("name");

                if (!name) return;

                const type = $field.attr("type");

                if (type === "checkbox") {
                  data[name] = $field.is(":checked");
                } else if (type === "radio") {
                  if ($field.is(":checked")) {
                    data[name] = $field.val();
                  }
                } else {
                  data[name] = $field.val();
                }
              });

            localStorage.setItem("fc_checkout_fields", JSON.stringify(data));
          });

          function restoreFields() {
            const stored = localStorage.getItem("fc_checkout_fields");
            if (!stored) return;

            let data;

            try {
              data = JSON.parse(stored);
            } catch (e) {
              localStorage.removeItem("fc_checkout_fields");
              return;
            }

            if (!data || typeof data !== "object") {
              localStorage.removeItem("fc_checkout_fields");
              return;
            }

            Object.entries(data).forEach(([name, value]) => {
              const $field = $form.find(`[name="${name}"]`);

              if (!$field.length) return;

              if ($field.attr("type") === "checkbox") {
                $field.prop("checked", value).trigger("change");
              } else {
                $field.val(value).trigger("change");
              }
            });

            if (!$("input#fc-billing-fields").is(":checked")) {
              syncShippingToBilling();
            }
          }

          // Routing

          const router = new Navigo(routerBasename, true);

          const steps = main.initSteps();

          function getRequiredFieldValue($field) {
            if ($field.attr("type") === "checkbox") {
              return $field.is(":checked") ? "1" : "";
            }

            return ($field.val() || "").toString().trim();
          }

          function isAddressAutocompleteComplete($wrapper) {
            const type = $wrapper.hasClass("billing") ? "billing" : "shipping";

            return Boolean(
              $(`#${type}_address_1`).val().trim() &&
              $(`#${type}_postcode`).val().trim() &&
              $(`#${type}_city`).val().trim()
            );
          }

          function isAddressRequiredFieldSkipped($required) {
            if (
              $required.hasClass("fc-hidden") ||
              $required.hasClass("hidden") ||
              $required.closest(".fc-hidden, .hidden").length
            ) {
              return true;
            }

            // Fields hidden via inline styles (e.g. account password while
            // "create account" is unchecked). ":visible" can't be used since
            // the whole address step is hidden while on another step.
            const isHiddenByStyle = $required.parentsUntil($address).addBack()
              .filter((_, el) => $(el).css("display") === "none")
              .length > 0;

            if (isHiddenByStyle) {
              return true;
            }

            return $required.closest(".fc-billing-fields").length > 0 &&
              !$("input#fc-billing-fields").is(":checked");
          }

          function isAddressStepComplete() {
            if (!$("input#fc-billing-fields").is(":checked")) {
              syncShippingToBilling();
            }

            let isComplete = true;

            $address.find(".validate-required").each(function () {
              const $required = $(this);

              if (isAddressRequiredFieldSkipped($required)) {
                return;
              }

              if ($required.hasClass("ec-address__autocomplete")) {
                if (!isAddressAutocompleteComplete($required)) {
                  isComplete = false;
                  return false;
                }

                return;
              }

              const $field = $required.find("input, select, textarea")
                .not(":button, :submit, :reset, [type='hidden']")
                .first();

              if ($field.length > 0 && !getRequiredFieldValue($field)) {
                isComplete = false;
                return false;
              }
            });

            return isComplete;
          }

          steps.getItemsArray().forEach(({ step, path, node, external }) => {

            if (external) {
              return;
            }

            let hooks = {
              before: (done) => {
                if (step === "payment") {
                  if (!$("input#fc-billing-fields").is(":checked")) {
                    syncShippingToBilling();
                  }

                  if (!isAddressStepComplete()) {
                    router.navigate(steps.getItems().address.path);
                    done(false);
                    return;
                  }
                }
                done();
              },
            };

            router.on(path, () => {
              steps.setStep(step);
              $(`.fc-checkout-steps__item#${node}`).show();
              $(document.body).trigger("fc_step", [step]);
              $("#current_step").val(step);

              // Analytics
              main.analytics.onStepReached(step);

            }, hooks);

          });

          // Fix Klarna payments purchase approval popup
          router.on("kp=*", () => {
            steps.setStep("payment");
            $(`.fc-checkout-steps__item#${steps.getCurrentStep().node}`).show();
          });

          router.on("*", () => {

            let defaultStep;

            steps.getItemsArray().forEach(function ({ step, external }) {
              if (!external && defaultStep === undefined) {
                defaultStep = step;
                return false;
              }
            });

            steps.setStep(defaultStep);
            $(`.fc-checkout-steps__item#${steps.getCurrentStep().node}`).show();

            // Analytics
            main.analytics.onStepReached(defaultStep);

          });

          router.hooks({
            before: function (done, params) {
              $(".fc-checkout-steps__item").hide();
              syncCustomerInfoBox();
              done();
            },
            after: function () {
              if (main.isMobile() && settings.openCartOnMobile && steps.getCurrentStepIndex() !== 0) {
                $("html, body").animate({
                  scrollTop: $(".fc-sidebar__progress-bar").offset().top - 5,
                });
              } else {
                $("html, body").animate({ scrollTop: 0 });
              }
            },
          });

          restoreFields();
          router.resolve();

          $(".fc-progress-bar").on("fc-step-choose", function (e, { path, external }) {
            if (!external) {
              router.navigate(path);
            }
          });

          $(".fc-nav-btn").on("click", function (e) {

            const to = $(this).data("to");

            if (steps.getItems()[to] !== undefined) {
              e.preventDefault();
              router.navigate(steps.getItems()[to].path);
            }

          });

          $(".fc-next-nav-btn").on("click", function (e) {

            const nextStep = steps.getNextStep();

            if (nextStep) {
              e.preventDefault();
              router.navigate(nextStep.path);
            }

          });

          $(".fc-open-login-popup").magnificPopup({
            type: "inline",
            midClick: true,
            closeBtnInside: false,
          });

          $address.on("focusin", ".input-text, gmp-place-autocomplete", function () {
            $(this).closest(".form-row").addClass("fc-focus");
          }).on("focusout", ".input-text, gmp-place-autocomplete", function () {
            $(this).closest(".form-row").removeClass("fc-focus");
          }).on("change", ".input-text, gmp-place-autocomplete", function () {
            if ((this.value || "").trim() !== "") {
              $(this).closest(".form-row").addClass("fc-not-empty");
            } else {
              $(this).closest(".form-row").removeClass("fc-not-empty");
            }
          });

          $("input#fc-billing-fields").change(function () {
            if ($(this).is(":checked")) {

              Object.values(shippingToBillingMapping).forEach(key => {

                const $field = $("#" + key);

                if ($field.closest(".fc-field").hasClass("fc-hidden")) {
                  return;
                }

                $field.val("");

              });

              if ($("select#billing_country option[value=\"" + defaultCountry + "\"]").length) {
                $("select#billing_country").val(defaultCountry);
              }

              $(".fc-billing-fields")
                .slideDown(slideDuration)
                .find(".form-row")
                .removeClass("woocommerce-validated woocommerce-invalid");

            } else {
              $(".fc-billing-fields").slideUp(slideDuration, () => {
                syncShippingToBilling();
              });
            }
          });

          // Show/Hide company field.
          const $companyFieldWrapper = $(".fc-field-shipping_company, .fc-field-billing_company"),
            $vatIdFieldWrapper = $(".fc-field-shipping_vat_id, .fc-field-billing_vat_id"),
            $showCompanyField = $("input[name=\"fc_show_company_field\"]");

          $showCompanyField.on("change", function () {
            if ($companyFieldWrapper.hasClass("fc-hidden")) {
              $companyFieldWrapper.hide().removeClass("fc-hidden");
            }

            const isChecked = $(this).is(":checked");

            $companyFieldWrapper[isChecked ? "slideDown" : "slideUp"]();
            $vatIdFieldWrapper[isChecked ? "slideDown" : "slideUp"]();
          });

          // Show/Hide order comment field.
          $("input[name=\"fc_show_order_comments_field\"]").change(function () {

            const $orderCommentsField = $(this).parent().siblings(".fc-field-order_comments");

            if ($orderCommentsField.hasClass("fc-hidden")) {
              $orderCommentsField.hide().removeClass("fc-hidden");
            }

            $orderCommentsField[$(this).is(":checked") ? "slideDown" : "slideUp"]();
          });

          $("input#createaccount").change(function () {
            if ($(this).is(":checked")) {
              $(".fc-create-account")
                .slideDown(slideDuration)
                .find(".form-row")
                .removeClass("woocommerce-validated woocommerce-invalid");
            } else {
              $(".fc-create-account").slideUp(slideDuration);
            }
          });

          $(Object.keys(shippingToBillingMapping).map(key => "#" + key).join(",")).change(function () {

            if ($("input#fc-billing-fields").is(":checked")) {
              return;
            }

            $("#" + shippingToBillingMapping[$(this).attr("id")]).val($(this).val());
          });

          function validateAutocompleteField($wrapper, fieldType) {
            // The Google element, or the native input of the address autofill test.
            const inputValue = ($wrapper.find("gmp-place-autocomplete, input[type='text']")[0]?.value || "").trim();
            const isRequired = $wrapper.hasClass("validate-required");

            const addressField = $(`#${fieldType}_address_1`).val().trim();
            const postcodeField = $(`#${fieldType}_postcode`).val().trim();
            const cityField = $(`#${fieldType}_city`).val().trim();

            const hasCompleteAddress = addressField && postcodeField && cityField;

            if (inputValue && hasCompleteAddress) {
              $wrapper.addClass("woocommerce-validated").removeClass("woocommerce-invalid");
              return true;
            } else if (isRequired && inputValue && !hasCompleteAddress) {
              $wrapper.addClass("woocommerce-invalid").removeClass("woocommerce-validated");
              return false;
            } else if (isRequired && !inputValue) {
              $wrapper.addClass("woocommerce-invalid").removeClass("woocommerce-validated");
              return false;
            } else {
              $wrapper.removeClass("woocommerce-invalid woocommerce-validated");
              return true;
            }
          }

          for (const type of ["billing", "shipping"]) {
            const $autoCompleteWrapper = $(`.ec-address__autocomplete.${type}`),
              fields = $(`.ec-address__fields.${type}`);

            const $country = $(`select[name="${type}_country"]`);

            const $input = $autoCompleteWrapper.find("input[type='text']");

            let placeAutocomplete;

            const isAddressAutofillTest = main.epsilonLabExperiments.googleAddressAutofill();

            let $autofillHiddenControls = $();

            let leaveAddressSearch = () => {};

            function getIncludedRegionCodes() {
              const country = $country.val();

              return country ? [country.toLowerCase()] : [];
            }

            $country.on("change", function () {
              if (placeAutocomplete) {
                placeAutocomplete.includedRegionCodes = getIncludedRegionCodes();
              }

              const $vatField = $(`.fc-field-${type}_vat_id`);

              $vatField.hide().toggleClass("fc-hidden", $country.val() === "DE");
              if ($showCompanyField.is(":checked")) {
                $vatField.show();
              }
            }).trigger("change");

            function enterManually() {
              $autoCompleteWrapper.hide();
              fields.addClass("show").removeClass("ec-address__fields--autofill-target");
              $autoCompleteWrapper.removeClass("woocommerce-invalid woocommerce-validated");

              $autofillHiddenControls.removeAttr("tabindex");
              $autofillHiddenControls = $();

              leaveAddressSearch();
            }

            function setSearchValue(value) {
              if (placeAutocomplete) {
                placeAutocomplete.value = value;
              } else {
                $input.val(value);
              }
            }

            function getAddress(type) {
              const address1 = $(`#${type}_address_1`).val()?.trim() || null;
              const postcode = $(`#${type}_postcode`).val()?.trim() || null;
              const city = $(`#${type}_city`).val()?.trim() || null;

              return {
                address1,
                postcode,
                city,
                isComplete: Boolean(address1 && postcode && city)
              };
            }

            function useSelectedPlace(place) {
              if (!place.addressComponents) {
                return;
              }

              const address = place.addressComponents.reduce((acc, component) => {
                component.types.forEach(componentType => {
                  acc[componentType] = componentType === "country"
                    ? component.shortText
                    : component.longText;
                });

                return acc;
              }, {});

              const addressString = `${address.route ?? ""} ${address.street_number ?? ""}`.trim();
              const city = address.locality ?? address.postal_town ?? address.sublocality_level_1 ?? "";

              $(`#${type}_address_1`).val(addressString);
              $(`#${type}_postcode`).val(address.postal_code ?? "");
              $(`#${type}_city`).val(city);
              $(`#${type}_country`).val(address.country ?? "");

              setSearchValue(place.formattedAddress ?? "");

              $(`#${type}_address_1, #${type}_postcode, #${type}_city, #${type}_country`)
                .trigger("validate").blur();

              if (type === "shipping" && !$("input#fc-billing-fields").is(":checked")) {
                syncShippingToBilling();
              }

              validateAutocompleteField($autoCompleteWrapper, type);

              enterManually(type);
            }

            async function initPlaceAutocomplete() {
              try {
                const { PlaceAutocompleteElement } = await google.maps.importLibrary("places");

                placeAutocomplete = new PlaceAutocompleteElement({
                  includedPrimaryTypes: ["street_address", "route", "premise", "subpremise", "intersection"],
                  includedRegionCodes: getIncludedRegionCodes(),
                  name: $input.attr("name"),
                  noInputIcon: true,
                  placeholder: $input.attr("placeholder"),
                  value: $input.val() || "",
                });

                if ($input.attr("id")) {
                  placeAutocomplete.id = $input.attr("id");
                }

                $input.replaceWith(placeAutocomplete);

                placeAutocomplete.addEventListener("input", function () {
                  if (main.isMobile() && placeAutocomplete.value.trim() !== "") {
                    window.scrollTo(0, 0);
                  }

                  validateAutocompleteField($autoCompleteWrapper, type);
                });

                placeAutocomplete.addEventListener("gmp-select", async function ({ placePrediction }) {
                  try {
                    const place = placePrediction.toPlace();
                    await place.fetchFields({
                      fields: ["addressComponents", "formattedAddress"],
                    });

                    useSelectedPlace(place);
                  } catch (error) {
                    console.error("Unable to fetch the selected address.", error);
                    enterManually(type);
                  }
                });

                placeAutocomplete.addEventListener("gmp-error", function () {
                  enterManually(type);
                });
              } catch (error) {
                console.error("Unable to initialize Google Place Autocomplete.", error);
                enterManually(type);
              }
            }

            async function initAddressAutofill() {
              const autofillToken = `section-${type} ${type} address-line1`;
              const listId = `ec-address-search-${type}-list`;
              const $address1 = $(`#${type}_address_1`);
              const address1Type = $address1.attr("type");
              const $addressFields = $(`#${type}_address_1, #${type}_postcode, #${type}_city`);

              const $list = $("<ul>", { id: listId, class: "ec-address-search__list", role: "listbox" });

              let suggestions = [];
              let activeIndex = -1;
              let sessionToken = null;
              let requestId = 0;
              let debounceTimer = null;

              leaveAddressSearch = () => {
                clearTimeout(debounceTimer);
                requestId++;

                $address1.attr("type", address1Type);
              };

              $input.attr({
                autocomplete: autofillToken,
                role: "combobox",
                "aria-autocomplete": "list",
                "aria-expanded": "false",
                "aria-controls": listId,
              }).after($list);

              $autoCompleteWrapper.addClass("ec-address__autocomplete--autofill");
              fields.addClass("ec-address__fields--autofill-target");

              $autofillHiddenControls = fields.find("input, select, textarea").filter(":not([tabindex])").attr("tabindex", "-1");

              $address1.attr("type", "hidden");

              if (type === "shipping") {
                $("#billing_email").attr("autocomplete", "section-shipping shipping email");
                $("#billing_phone").attr("autocomplete", "section-shipping shipping tel");
              }

              $addressFields.on("input change", () => {
                setTimeout(() => {
                  if (fields.hasClass("ec-address__fields--autofill-target") && !$address1.val().trim()) {
                    $address1.val($input.val().trim());
                  }

                  const { address1, postcode, city } = getAddress(type);

                  if (!fields.hasClass("ec-address__fields--autofill-target") || !(address1 || postcode || city)) {
                    return;
                  }

                  closeList();
                  $addressFields.add(`#${type}_country`).trigger("validate");
                  enterManually(type);
                }, 0);
              });

              function closeList() {
                suggestions = [];
                activeIndex = -1;
                $list.empty().removeClass("is-open");
                $input.attr("aria-expanded", "false").removeAttr("aria-activedescendant");
              }

              function renderList() {
                $list.empty();

                if (!suggestions.length) {
                  closeList();
                  return;
                }

                suggestions.forEach((prediction, index) => {
                  $("<li>", {
                    id: `${listId}-${index}`,
                    class: "ec-address-search__option",
                    role: "option",
                    "aria-selected": index === activeIndex ? "true" : "false",
                  })
                    .toggleClass("is-active", index === activeIndex)
                    .append($("<span>", { class: "ec-address-search__main", text: prediction.mainText?.text ?? prediction.text.text }))
                    .append($("<span>", { class: "ec-address-search__secondary", text: prediction.secondaryText?.text ?? "" }))
                    .data("index", index)
                    .appendTo($list);
                });

                $("<li>", { class: "ec-address-search__attribution", text: "powered by Google", "aria-hidden": "true" }).appendTo($list);

                $list.addClass("is-open");
                $input.attr("aria-expanded", "true");

                if (activeIndex >= 0) {
                  $input.attr("aria-activedescendant", `${listId}-${activeIndex}`);
                } else {
                  $input.removeAttr("aria-activedescendant");
                }
              }

              let places;

              try {
                places = await google.maps.importLibrary("places");
              } catch (error) {
                console.error("Unable to initialize Google Place Autocomplete.", error);
                enterManually(type);
                return;
              }

              async function fetchSuggestions(value) {
                const currentRequest = ++requestId;

                if (!sessionToken) {
                  sessionToken = new places.AutocompleteSessionToken();
                }

                try {
                  const response = await places.AutocompleteSuggestion.fetchAutocompleteSuggestions({
                    input: value,
                    sessionToken,
                    language: "de",
                    includedPrimaryTypes: ["street_address", "route", "premise", "subpremise", "intersection"],
                    includedRegionCodes: getIncludedRegionCodes(),
                  });

                  if (currentRequest !== requestId || $input.val().trim() === "") {
                    return;
                  }

                  suggestions = response.suggestions.map(suggestion => suggestion.placePrediction).filter(Boolean);
                  activeIndex = -1;
                  renderList();
                } catch (error) {
                  console.error("Unable to fetch Google address suggestions.", error);
                  closeList();
                  enterManually(type);
                }
              }

              async function selectSuggestion(index) {
                const prediction = suggestions[index];

                if (!prediction) {
                  return;
                }

                closeList();
                $input.val(prediction.text.text);

                try {
                  const place = prediction.toPlace();
                  await place.fetchFields({
                    fields: ["addressComponents", "formattedAddress"],
                  });

                  sessionToken = null;
                  useSelectedPlace(place);
                } catch (error) {
                  console.error("Unable to fetch the selected address.", error);
                  enterManually(type);
                }
              }

              $input.on("input", function () {
                const value = this.value.trim();

                this.setAttribute("autocomplete", value === "" ? autofillToken : "off");

                if (main.isMobile() && value !== "") {
                  window.scrollTo(0, 0);
                }

                validateAutocompleteField($autoCompleteWrapper, type);

                clearTimeout(debounceTimer);

                if (value === "") {
                  requestId++;
                  closeList();
                  return;
                }

                debounceTimer = setTimeout(() => fetchSuggestions(value), 200);
              });

              $input.on("keydown", function (e) {
                if (!suggestions.length) {
                  return;
                }

                if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                  e.preventDefault();

                  activeIndex = (activeIndex + (e.key === "ArrowDown" ? 1 : -1) + suggestions.length) % suggestions.length;
                  renderList();
                } else if (e.key === "Enter") {
                  e.preventDefault();
                  selectSuggestion(activeIndex >= 0 ? activeIndex : 0);
                } else if (e.key === "Escape") {
                  closeList();
                }
              });

              $input.on("blur", () => setTimeout(closeList, 150));

              $list.on("mousedown", ".ec-address-search__option", function (e) {
                e.preventDefault();
                selectSuggestion($(this).data("index"));
              });
            }

            if (isAddressAutofillTest) {
              initAddressAutofill();
            } else {
              initPlaceAutocomplete();
            }

            const address = getAddress(type);

            if (address.isComplete) {
              enterManually(type);
            }

            $autoCompleteWrapper.find(".ec-address__manually-link").on("click", () => enterManually(type));
          }

          // Process address step
          $(".fc-submit-address").click(function (e) {
            e.preventDefault();

            let autocompleteValid = true;
            $(".ec-address__autocomplete").each(function() {
              const $wrapper = $(this);

              if ($wrapper.is(":visible")) {
                const type = $wrapper.hasClass('billing') ? 'billing' : 'shipping';
                const isValid = validateAutocompleteField($wrapper, type);

                if (!isValid) {
                  autocompleteValid = false;
                }
              }
            });

            $address.find(".input-text, gmp-place-autocomplete, select, input:checkbox")
              .trigger("validate").blur();

            if ($address.find(".woocommerce-invalid:visible").length === 0 && autocompleteValid) {
              router.navigate(steps.getNextStep().path);
            } else {
              const $firstInvalid = $address.find(".woocommerce-invalid:visible").first();

              if ($firstInvalid.length > 0 && $firstInvalid.offset()) {
                const scrollTop = $firstInvalid.offset().top - 5;

                if ($("html").scrollTop() > scrollTop) {
                  $("html, body").animate({ scrollTop: scrollTop });
                }
              }
            }
          });

          // Allow only numbers on the shipping_postcode field
          $("#shipping_postcode").on("input", function () {
            if ($("#shipping_country").val() === "DE") {
              this.value = this.value.replace(/[^0-9]/g, "");
            } else {
              this.value = this.value.replace(/[^a-zA-Z0-9]/g, "");
            }
          });

          // Process shipping step
          $(".fc-submit-shipping").click(function (e) {
            e.preventDefault();

            const $deliverDate = $(".fc-shipping-methods__item.active input[name=\"fc_delivery_date\"]");

            if ($deliverDate.length === 0 || $deliverDate.is(":checked")) {
              router.navigate(steps.getNextStep().path);
            } else {
              alert("Bitte wählen Sie zunächst Ihren Liefertermin.");
            }
          });

          // Display the delivery date in the order review if it's selected.
          function updateOrderReviewDeliveryDate() {
            const $deliveryDate = $(".fc-shipping-methods__item.active input[name=\"fc_delivery_date\"]:checked"),
              $deliveryInfo = $(".wc-gzd-cart-info.delivery-time-info");

            // Reset to default state.
            $deliveryInfo.show();
            $(".fc-order-review-delivery-date").remove();

            // Display actual date.
            if ($deliveryDate.data("date")) {
              $deliveryInfo.hide()
                .after("<p class=\"fc-order-review-delivery-date\">Lieferzeit: " + $deliveryDate.data("date") + "</p>");
            }
          }

          $form
            .on("change", "input[name=\"fc_delivery_date\"]", updateOrderReviewDeliveryDate)
            .on("change", "input.shipping_method", updateOrderReviewDeliveryDate);

          $body.on("updated_checkout", updateOrderReviewDeliveryDate);


          // Remove product from cart
          $form.on("click", ".fc-order-review__remove-product", function (e) {

            const key = $(this).data("key"),
              productId = $(this).data("product-id"),
              variationId = $(this).data("variation-id");

            main.enableLoader();

            const data = {
              action: "fc_remove_from_cart",
              cart_item_key: key,
            };

            $.ajax({
              type: "POST",
              url: flatsomeCheckoutData.ajaxUrl,
              data: data,
              success: function (resp) {
                if (resp.success) {

                  const id = `${productId}_${variationId}`,
                    $crossSell = $("input[name=\"active-cross-sells[]\"][value=\"" + id + "\"]");

                  if ($crossSell.is(":checked")) {
                    $crossSell.prop("checked", false).change();
                  }

                  $(document.body).trigger("fc_remove_from_cart", [productId, variationId]);

                  $(document.body).trigger("update_checkout", { update_shipping_method: false });
                } else {
                  alert("Remove error");
                }
              },
              complete: function () {
                main.disableLoader();
              },
            });

          });

          // Open coupon form
          $form.on("click", ".fc-coupon-form__open", function (e) {
            e.preventDefault();
            const $holder = $(this).closest(".fc-coupon-form");
            $holder.find(".fc-coupon-form__form").slideToggle();
          });

          $form.on("keydown", ".fc-coupon-form__input", function (e) {
            if (e.key !== "Enter" || e.originalEvent?.isComposing) {
              return;
            }

            e.preventDefault();
            $(this).closest(".fc-coupon-form").find(".fc-coupon-form__submit").trigger("click");
          });

          // Apply coupon
          $form.on("click", ".fc-coupon-form__submit", function (e) {

            e.preventDefault();

            const $holder = $(this).closest(".fc-coupon-form");

            const $errors = $holder.find(".fc-coupon-form__errors");
            $errors.html("");

            main.enableLoader();

            const data = {
              action: "fc_apply_coupon",
              security: wc_checkout_params.apply_coupon_nonce,
              coupon_code: $holder.find(".fc-coupon-form__input").val(),
            };

            $.ajax({
              type: "POST",
              url: flatsomeCheckoutData.ajaxUrl,
              data: data,
              success: function (resp) {
                if (resp.success) {
                  $(document.body).trigger("applied_coupon_in_checkout", [data.coupon_code]);
                  $(document.body).trigger("update_checkout", { update_shipping_method: false });

                  // Analytics
                  main.analytics.onValidCouponApplied(data.coupon_code);

                } else {
                  $errors.html(Array.isArray(resp.data) ? resp.data.join("\n") : resp.data);

                  // Analytics
                  main.analytics.onInvalidCouponApplied(data.coupon_code);

                }
              },
              complete: function () {
                main.disableLoader();
              },
            });

          });

          // Mobile order summary toggle
          $(".fc-sidebar__header").click(function () {

            const $block = $(".fc-sidebar__order-review"),
              isVisible = $block.is(":visible");

            $block.slideToggle();

            $(".fc-sidebar__toggle")[(isVisible ? "remove" : "add") + "Class"]("fc-sidebar__toggle--opened");

          });

          function validateStreetAndHouseNumber($input) {
            const $fieldHolder = $input.closest(".fc-field"),
              $field = $fieldHolder.find(".form-row"),
              $errors = $fieldHolder.find(".fc-field__errors");

            const errorMsg = "Bitte überprüfen Sie Ihre Angabe.";

            $field.removeClass("woocommerce-validated woocommerce-invalid");
            $errors.html("");

            if (!/^([\s\w\W.]+)\s+(\d+\w?)/.test($input.val())) {
              $field.addClass("woocommerce-invalid");
              $errors.html(errorMsg);

              return false;
            }

            $field.addClass("woocommerce-validated");

            return true;
          }

          function validateStreetAndHouseNumberBeforeSubmit() {
            if (!$("input#fc-billing-fields").is(":checked")) {
              syncShippingToBilling();
            }

            $("#billing_address_1, #shipping_address_1").each(function () {
              validateStreetAndHouseNumber($(this));
            });

            const $firstInvalid = $form.find(".woocommerce-invalid:visible").first();

            if ($firstInvalid.length === 0) {
              return true;
            }

            if ($firstInvalid.offset()) {
              $("html, body").animate({ scrollTop: $firstInvalid.offset().top - 5 });
            }

            return false;
          }

          function validatePostcodeLength($input) {
            if (!$input.is("#billing_postcode, #shipping_postcode")) {
              return true;
            }

            const type = $input.attr("id").indexOf("billing_") === 0 ? "billing" : "shipping",
              country = ($(`#${type}_country`).val() || defaultCountry).toUpperCase(),
              postcode = $input.val().trim(),
              postcodePattern = country === "AT" ? /^\d{4}$/ : /^\d{5}$/;

            if (postcode && !postcodePattern.test(postcode)) {
              $input.closest(".form-row")
                .removeClass("woocommerce-validated")
                .addClass("woocommerce-invalid");

              return false;
            }

            return true;
          }

          function clearFieldValidation($input) {
            const $fieldHolder = $input.closest(".fc-field");

            $fieldHolder.find(".form-row").removeClass("woocommerce-validated woocommerce-invalid");
            $fieldHolder.find(".fc-field__errors").html("");
          }

          function validateRequiredField($input) {
            const $required = $input.closest(".validate-required");

            if (isAddressRequiredFieldSkipped($required)) {
              return false;
            }

            if (!$input.val().trim()) {
              clearFieldValidation($input);
              return false;
            }

            $input.trigger("validate");
            validatePostcodeLength($input);
            setTimeout(() => validatePostcodeLength($input), 0);

            return true;
          }

          function validatePostcodeForCountry($input) {
            if (!$input.is("#billing_country, #shipping_country")) {
              return;
            }

            const type = $input.attr("id").indexOf("billing_") === 0 ? "billing" : "shipping",
              $postcode = $(`#${type}_postcode`);

            if ($postcode.val().trim()) {
              validateRequiredField($postcode);
            }
          }

          // Validate address field
          $("body").on("focusout change", "#billing_address_1, #shipping_address_1", function () {

            const $input = $(this);

            if (validateRequiredField($input)) {
              validateStreetAndHouseNumber($input);
            }

          });

          $address.on("focusout change", ".validate-required input, .validate-required select, .validate-required textarea", function () {
            const $input = $(this);

            if ($input.is(":button, :submit, :reset, [type='hidden'], #billing_address_1, #shipping_address_1")) {
              return;
            }

            validateRequiredField($input);
            validatePostcodeForCountry($input);
          });

          $form.on("checkout_place_order", validateStreetAndHouseNumberBeforeSubmit);

          const $taxIDField = $("#fc_shipping_vat_id"),
            $shippingCompanyField = $("#shipping_company");

          const $billingTaxIDField = $("#fc_billing_vat_id"),
            $billingCompanyField = $("#billing_company");

          [[$taxIDField, $shippingCompanyField], [$billingTaxIDField, $billingCompanyField]].forEach(([$vatField, $companyField]) => {

            if ($vatField.length === 0) {
              return;
            }

            $companyField.on("change", function () {

              const isEmpty = $(this).val().trim().length === 0;

              if (flatsomeCheckoutData.settings.taxIDField === "required_if_company") {
                isEmpty ? switchFieldToOptional($vatField) : switchFieldToRequired($vatField);
              }
            }).trigger("change");
          });

          // Cross-sells more info popup
          $(".fc-open-cross-sell-popup").magnificPopup({
            type: "inline",
          });

          // Cross-sell product image popup
          $("img[data-lightbox-image]").magnificPopup({
            type: "image",
            closeBtnInside: false,
            callbacks: {
              elementParse: function (item) {

                let src = item.el.attr("data-original-url");

                if (!src) {
                  src = item.el.attr("src");
                }

                item.src = src;
              },
            },
          });

          // Handle Cross Sell Checkbox Toggle
          $form.on("change", "input[name=\"active-cross-sells[]\"]", function (e) {
            if ($(this).prop("checked")) {
              main.analytics.onCrossSellAddedToCart($(this).val(), $(this).data("name"));
              $(this).closest(".fc-add-to-cart").addClass("fc-in-cart");
            } else {
              main.analytics.onCrossSellRemovedFromCart($(this).val(), $(this).data("name"));
              $(this).closest(".fc-add-to-cart").removeClass("fc-in-cart");
            }
          });

          $("body").on("click", ".fc-add-to-cart .fc-submit", function (e) {
            e.preventDefault();

            $(this).closest(".fc-add-to-cart").find("input[name=\"active-cross-sells[]\"]")
              .prop("checked", true).change();
          });

          $("body").on("click", ".fc-add-to-cart .fc-remove", function (e) {
            e.preventDefault();

            $(this).closest(".fc-add-to-cart").find("input[name=\"active-cross-sells[]\"]")
              .prop("checked", false).change();
          });

          $("select.fc-attribute__select").change(function () {
            const $holder = $(this).closest(".fc-product"),
              $img = $holder.find("header img"),
              $variations = $(this).closest(".fc-variations"),
              $attributeFields = $variations.find("select.fc-attribute__select"),
              variationData = $variations.data("variations"),
              currentAttributes = {};
            let variation = false;

            $attributeFields.each(function () {
              currentAttributes[$(this).data("attribute_name")] = $(this).val();
            });

            $.each(variationData, function (i, v) {
              if (main.utils.isEqual(v.attributes, currentAttributes)) {
                variation = v;
                return false;
              }
            });

            // Save the default image for further restoration.
            if (!$img.data("default-src")) {
              $img.data("default-src", $img.attr("src"));
              $img.data("default-original-url", $img.attr("data-original-url"));
            }

            if (variation) {

              $(".fc-variation-info").attr("data-variation-id", variation.variation_id);

              let $variationInfo = $variations.find(".fc-variation-info[data-variation-id=\"" + variation.variation_id + "\"]");

              $.ajax({
                url: flatsomeCheckoutData.ajaxUrl,
                type: "POST",
                data: {
                  action: "fc_load_cross_sells_variations",
                  variation_id: variation.variation_id,
                },
                beforeSend: function () {
                  // Use the variable for the selector
                  let $priceElement = $variationInfo.find(".woocommerce-Price-amount.amount");
                  $priceElement.data("original-content", $priceElement.html()).html("0,00 €").css("filter", "blur(1px)");

                  $variationInfo.closest(".fc-product").block({
                    message: null,
                    overlayCSS: {
                      background: "#FFF",
                      opacity: 0.6,
                    },
                  });

                },
                success: function (response) {
                  if (response.success) {
                    $variationInfo.closest(".fc-product").unblock();
                    $variationInfo.html(response.data).find(".fc-add-to-cart").unblock();
                    let $updatedPriceElement = $variationInfo.find(".woocommerce-Price-amount.amount");
                    $updatedPriceElement.html($updatedPriceElement.data("original-content")).css("filter", "");
                  }
                },
                error: function () {
                  // Use the variable for error handling
                  let $priceElement = $variationInfo.find(".woocommerce-Price-amount.amount");
                  $priceElement.html($priceElement.data("original-content")).css("filter", "");
                },
              });

              $img.attr("src", variation.image.src);
              $img.attr("data-original-url", variation.image.original_url);
            } else {
              $img.attr("src", $img.data("default-src"));
              $img.attr("data-original-url", $img.data("default-original-url"));
            }

            // Copied from WC.
            // Loop through selects and disable/enable options based on selections.
            $attributeFields.each(function (index, el) {
              const current_attr_select = $(el),
                current_attr_name = current_attr_select.data("attribute_name"),
                show_option_none = $(el).data("show_option_none");
              let option_gt_filter = ":gt(0)",
                attached_options_count = 0;
              const new_attr_select = $("<select/>"),
                selected_attr_val = current_attr_select.val() || "";
              let selected_attr_val_valid = true;

              // Reference options set at first.
              if (!current_attr_select.data("attribute_html")) {
                const refSelect = current_attr_select.clone();

                refSelect.find("option").removeAttr("attached").prop("disabled", false).prop("selected", false);

                // Legacy data attribute.
                current_attr_select.data(
                  "attribute_options",
                  refSelect.find("option" + option_gt_filter).get(),
                );
                current_attr_select.data("attribute_html", refSelect.html());
              }

              new_attr_select.html(current_attr_select.data("attribute_html"));

              // The attribute of this select field should not be taken into account when calculating its matching variations:
              // The constraints of this attribute are shaped by the values of the other attributes.
              const checkAttributes = $.extend(true, {}, currentAttributes);

              checkAttributes[current_attr_name] = "";

              const variations = main.variationUtils.findMatchingVariations(variationData, checkAttributes);

              // Loop through variations.
              for (let num in variations) {
                if (typeof (variations[num]) !== "undefined") {
                  const variationAttributes = variations[num].attributes;

                  for (let attr_name in variationAttributes) {
                    if (variationAttributes.hasOwnProperty(attr_name)) {
                      let attr_val = variationAttributes[attr_name];

                      if (attr_name === current_attr_name) {
                        if (attr_val) {
                          // Decode entities.
                          attr_val = $("<div/>").html(attr_val).text();

                          // Attach to matching options by value. This is done to compare
                          // TEXT values rather than any HTML entities.
                          const $option_elements = new_attr_select.find("option");
                          if ($option_elements.length) {
                            let i = 0;
                            const len = $option_elements.length;
                            for (; i < len; i++) {
                              var $option_element = $($option_elements[i]),
                                option_value = $option_element.val();

                              if (attr_val === option_value) {
                                $option_element.addClass("attached enabled");
                                break;
                              }
                            }
                          }
                        } else {
                          // Attach all apart from placeholder.
                          new_attr_select.find("option:gt(0)").addClass("attached enabled");
                        }
                      }
                    }
                  }
                }
              }

              // Count available options.
              attached_options_count = new_attr_select.find("option.attached").length;

              // Check if current selection is in attached options.
              if (selected_attr_val) {
                selected_attr_val_valid = false;

                if (0 !== attached_options_count) {
                  new_attr_select.find("option.attached.enabled").each(function () {
                    const option_value = $(this).val();

                    if (selected_attr_val === option_value) {
                      selected_attr_val_valid = true;
                      return false; // break.
                    }
                  });
                }
              }

              // Detach the placeholder if:
              // - Valid options exist.
              // - The current selection is non-empty.
              // - The current selection is valid.
              // - Placeholders are not set to be permanently visible.
              if (attached_options_count > 0 && selected_attr_val && selected_attr_val_valid && ("no" === show_option_none)) {
                new_attr_select.find("option:first").remove();
                option_gt_filter = "";
              }

              // Detach unattached.
              new_attr_select.find("option" + option_gt_filter + ":not(.attached)").remove();

              // Finally, copy to DOM and set value.
              current_attr_select.html(new_attr_select.html());
              current_attr_select.find("option" + option_gt_filter + ":not(.enabled)").prop("disabled", true);

              // Choose selected value.
              if (selected_attr_val) {
                // If the previously selected value is no longer available, fall back to the placeholder (it's going to be there).
                if (selected_attr_val_valid) {
                  current_attr_select.val(selected_attr_val);
                } else {
                  current_attr_select.val("").trigger("change");
                }
              } else {
                current_attr_select.val(""); // No change event to prevent infinite loop.
              }
            });
          }).change();

          $form.on("click", ".fc-shipping-methods > .row", function (e) {

            const $input = $(this).find("input.shipping_method"),
              checked = $input.prop("checked");

            if (!checked) {
              $input.prop("checked", true).change();
            }
          });

          $form.on("click", ".fc-shipping-dates__item", function (e) {

            const $input = $(this).find("input[name=\"fc_delivery_date\"]"),
              checked = $input.prop("checked");

            if (!checked) {
              $input.prop("checked", true).change();
            }

          }).on("change", ".fc-shipping-dates__item input[name=\"fc_delivery_date\"]", function () {

            $(".fc-shipping-dates__item").removeClass("active");
            $(this).closest(".fc-shipping-dates__item").addClass("active");

          }).on("change", ".fc-shipping-methods input.shipping_method", function () {

            $(".fc-shipping-methods__options-col").slideUp();
            $(this).closest(".row").find(".fc-shipping-methods__options-col").slideDown();

          }).on("click", ".fc-shipping-dates__load-more", function () {

            const $groups = $(this).closest(".fc-shipping-dates").find(".fc-shipping-dates__group");
            $groups.filter(":visible:last").next().slideDown();

            if ($groups.filter(":hidden").length === 0) {
              $(this).hide();
            }
          });

          $body.on("fc_step", function (e, step) {
            if (step === "shipping") {
              $(".fc-shipping-dates__item.active").trigger("click");

              $("body").on("updated_checkout", function () {
                $(".fc-shipping-dates__item.active").trigger("click");
              });
            }
          });

          $body.on("checkout_error", function (e, error_message) {

            const $errors = $(error_message).find(">li");

            if (
              $errors.length === 1 &&
              $errors.text().trim().indexOf("Allgemeinen Geschäftsbedingungen") !== -1
            ) {
              $("html, body").stop(true, false);
              $(".woocommerce-NoticeGroup-checkout").remove();
              $(".fc-order-review-section").after(error_message);

              const $submitButton = $(".fc-checkout-submit-btn"),
                scrollTo = $submitButton.offset().top + $submitButton.outerHeight() - $(window).height() + 5;

              if ($("html").scrollTop() < scrollTo) {
                $("html, body").animate({ scrollTop: scrollTo });
              }
            }
          });

          $body.on("updated_checkout", function () {
            syncCustomerInfoBox();
          });

          $body.on("country_to_state_changed", function (e, country) {

          });

          function syncCustomerInfoBox() {

            let billingEmail = $address.find("#billing_email").val(),
              billingCompany = $address.find("#billing_company").val(),
              billingFirstName = $address.find("#billing_first_name").val(),
              billingLastName = $address.find("#billing_last_name").val(),
              billingPhone = $address.find("#billing_phone").val(),
              $billingCountry = $address.find("#billing_country"),
              billingCountry = "",
              billingAddress1 = $address.find("#billing_address_1").val(),
              billingPostcode = $address.find("#billing_postcode").val(),
              billingCity = $address.find("#billing_city").val(),
              $shippingCountry = $address.find("#shipping_country"),
              shippingCountry = "",
              shippingAddress1 = $address.find("#shipping_address_1").val(),
              shippingPostcode = $address.find("#shipping_postcode").val(),
              shippingCity = $address.find("#shipping_city").val(),
              shippingMethod = $("#epsilon_checkout_shipping_method_label").val();

            if ($billingCountry.val() !== defaultCountry) {
              billingCountry = $billingCountry.find("option[value=\"" + $billingCountry.val() + "\"]").text();
            }

            if ($shippingCountry.val() !== defaultCountry) {
              shippingCountry = $shippingCountry.find("option[value=\"" + $shippingCountry.val() + "\"]").text();
            }

            // General
            $(".fc-customer-info__value--general").html(`${billingEmail}${billingPhone ? ", " + billingPhone : ""}`);

            // Shipping
            $(".fc-customer-info__value--shipping").html(`${shippingAddress1}, ${shippingPostcode} ${shippingCity} ${shippingCountry}`);

            // Billing
            const $billing = $(".fc-customer-info__value--billing"),
              $showBilling = $address.find("input#fc-billing-fields").is(":checked");

            let billing = "";

            if (billingCompany) {
              billing += `${billingCompany}, `;
            }

            billing += `${billingFirstName} ${billingLastName}, ${billingAddress1}, ${billingPostcode} ${billingCity} ${billingCountry}`;

            $billing.html(billing);

            $billing.parents(".fc-customer-info")[$showBilling ? "show" : "hide"]();

            // Shipping Info
            let shipping = shippingMethod ? shippingMethod : "Kostenlose Lieferung";

            const $deliveryDate = $(".fc-shipping-methods__item.active input[name=\"fc_delivery_date\"]:checked");

            if ($deliveryDate.data("date")) {
              shipping += ", " + $deliveryDate.data("date") + " " + "+ flexible Lieferterminabsprache";
            }

            $(".fc-customer-info__value--shipping-method").html(shipping);
          }

          function syncShippingToBilling() {
            Object.entries(shippingToBillingMapping).forEach(([shipping, billing]) => {
              const $shippingField = $("#" + shipping),
                $billingField = $("#" + billing);
              if ($shippingField.length > 0 && $billingField.length > 0) {
                $billingField.val($shippingField.val());
              }
            });
          }

          function switchFieldToOptional($field) {
            $field.closest(".form-row").removeClass("validate-required woocommerce-invalid woocommerce-invalid-required-field woocommerce-validated");
            const $label = $("label[for=\"" + $field.attr("id") + "\"]"),
              label = $label.text().replace(" *", " (optional)");
            $label.text(label);
            $field.prop("placeholder", label);
          }

          function switchFieldToRequired($field) {
            $field.closest(".form-row").removeClass("woocommerce-validated").addClass("validate-required");
            const $label = $("label[for=\"" + $field.attr("id") + "\"]"),
              label = $label.text().replace(" (optional)", " *");
            $label.text(label);
            $field.prop("placeholder", label);
          }
        },
      },

      thankYou: {

        init: function () {

          localStorage.removeItem("fc_checkout_fields");

          const router = new Navigo(null, true);
          const $surveyWrapper = $(".fc-survey");

          router.on({
            "survey": function () {
              main.pages.thankYou.setStep("survey");

              let $firstQuestion = $("#survey-question-0");
              if ($firstQuestion.length) {
                $(".fc-survey__question").hide();
                $firstQuestion.show().css({right: "0%", left: "0%", opacity: 1});
                $surveyWrapper.css({height: $firstQuestion.height()});
              }
            },
            "thankyou": function () {
              main.pages.thankYou.setStep("thankyou");
            },
          });

          if (window.location.hash.length === 0) {
            router.navigate("/" + $(".fc-order-received-steps__step:first-child").data("path"));
          }

          router.resolve();

          main.initSteps().setStep("completed");

          const answerOptionOther = $(".fc-survey__option-other");

          answerOptionOther.hide();

          let userAnswers = {};

          $(".fc-survey__options input[type='radio']").on("change", function () {
            let $this = $(this);
            let currentQuestionIndex = $this.data("question-index");
            let nextQuestionIndex = $this.data("next-question-index");
            let $currentQuestion = $("#survey-question-" + currentQuestionIndex);
            let $nextQuestion = $("#survey-question-" + nextQuestionIndex);
            let orderField = $currentQuestion.data("order-field");
            let answer = $this.val();
            let gaEventAction = $currentQuestion.data("ga-event-action");

            $surveyWrapper.css({height: $nextQuestion.height()});

            // Save the user's answer
            userAnswers[orderField] = answer;

            if (answer === "other") {
              answerOptionOther.show();
              $surveyWrapper.css({height: $currentQuestion.height()});
              $this.closest("li").addClass("fc-active");
            } else {

              answerOptionOther.hide();

              if (gaEventAction) {
                main.analytics.fireEvent(gaEventAction, gaEventAction + " - " + answer, answer);
              }

              $currentQuestion.find(".fc-survey__options li").removeClass("fc-active");
              $this.closest("li").addClass("fc-active").addClass("fc-animate");

              setTimeout(function () {
                $currentQuestion.animate({left: "-100%", opacity: 0}, 550, function () {
                  $currentQuestion.hide();
                });
              }, 250);

              setTimeout(function () {
                $nextQuestion.css({right: "-100%", left: "inherit", opacity: 0});
                $nextQuestion.show().animate({right: "0%", opacity: 1}, 550);
              }, 400);
            }

            if (!$nextQuestion.length) {
              saveAnswers(userAnswers, $currentQuestion.data("ga-event-action"), $currentQuestion.data("nonce"));
              setTimeout(function () {
                router.navigate("/thankyou");
              }, 250);
            }
          });

          $(".fc-survey__option-other textarea").on("input", function () {
            $(".fc-survey__option-other").removeClass("fc-error");
          });

          if (answerOptionOther.length) {
            $(".fc-survey__option-other textarea").on("input", function () {
              answerOptionOther.removeClass("fc-error");
            });

            $(".fc-survey__option-other button").on("click", function (e) {
              e.preventDefault();
              let $this = $("li.fc-active[class*=\"fc-survey__option-\"] input[type=\"radio\"]:checked");
              let currentQuestionIndex = $this.data("question-index");
              let nextQuestionIndex = $this.data("next-question-index");
              let $currentQuestion = $("#survey-question-" + currentQuestionIndex);
              let $nextQuestion = $("#survey-question-" + nextQuestionIndex);
              let orderField = $currentQuestion.data("order-field");
              let gaEventAction = $currentQuestion.data("ga-event-action");
              let value = answerOptionOther.find("textarea").val();

              if (value.length === 0) {
                answerOptionOther.addClass("fc-error");
                return;
              }

              $surveyWrapper.css({height: $nextQuestion.height()});

              // Save the user's answer
              userAnswers[orderField] = `other: ${answerOptionOther.find("textarea").val()}`;

              if (gaEventAction) {
                main.analytics.fireEvent(gaEventAction, gaEventAction, `other: ${value}`);
              }

              if (!$nextQuestion.length) {
                saveAnswers(userAnswers, $currentQuestion.data("ga-event-action"), $currentQuestion.data("nonce"));
                setTimeout(function () {
                  router.navigate("/thankyou");
                }, 250);
              } else {
                answerOptionOther.hide();

                $currentQuestion.find(".fc-survey__options li").removeClass("fc-active");
                $this.closest("li").addClass("fc-active").addClass("fc-animate");

                setTimeout(function () {
                  $currentQuestion.animate({left: "-100%", opacity: 0}, 550, function () {
                    $currentQuestion.hide();
                  });
                }, 250);

                setTimeout(function () {
                  $nextQuestion.css({right: "-100%", left: "inherit", opacity: 0});
                  $nextQuestion.show().animate({right: "0%", opacity: 1}, 550);
                }, 400);
              }
            });
          }

          $(".fc-register__form").submit(function (e) {

            e.preventDefault();

            const $errors = $(".fc-register__errors");

            $errors.html("");

            main.enableLoader();

            $.ajax({
              type: "POST",
              url: flatsomeCheckoutData.ajaxUrl + "?action=fc_register_customer",
              data: $(this).serialize(),
              success: function (resp) {
                if (resp.success) {
                  $(".fc-register__form").slideUp(() => {
                    $(".fc-register__success").slideDown();
                  });
                } else {
                  $errors.html(Array.isArray(resp.data) ? resp.data.join("\n") : resp.data);
                }
              },
              complete: function () {
                main.disableLoader();
              },
            });
          });

          function saveAnswers(answers, gaEventAction, nonce) {

            let dataToSave = {
              pps_questions: answers,
            };

            $.post(ajaxUrl + "?action=fc_save_survey_answer", {
              "_ajax_nonce": nonce,
              "order_id": $("#fc-order-id").val(),
              "field_key": "survey_results",
              "field_value": JSON.stringify(dataToSave),
            });
          }
        },

        setStep: function (path) {
          var $next = $(".fc-order-received-steps__step[data-path=\"" + path + "\"]");

          if ($next.is(":visible")) {
            return;
          }

          var $current = $(".fc-order-received-steps__step:visible");

          if ($current.length > 0) {
            $current.fadeOut(function () {
              $next.fadeIn();
            });
          } else {
            $next.show();
          }
        },
      },

      preStep: {
        init: function () {
          main.initSteps().setStep(location.pathname.replace(/^\/|\/$/g, ""));
        },
      },

    },

    analytics: {

      fireEvent: function (action, label, value, category = "Yournet Checkout") {

        label = label || false;
        value = value || false;

        if (!isAdmin) {
          if (window.gtag !== undefined && typeof window.gtag === "function") {

            window.gtag("event", action, {
              event_category: category,
              event_label: label,
              event_value: value,
            });

          } else {
            console.log("Event is not triggered. Analytic library is missing.");
          }
        } else {
          console.log("Analytics even is not triggered in administrator mode. Event data:", {
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value,
          });
        }
      },

      onStepReached: function (step) {

        let stepName = false;

        if (step === "cross-sell") {
          stepName = "CrossSells";
        } else if (step === "address") {
          stepName = "Address";
        } else if (step === "shipping") {
          stepName = "Shipping";
        } else if (step === "payment") {
          stepName = "Payment";
        }

        if (stepName) {
          this.fireEvent(`Step ${stepName} Opened`);
        }

      },

      onCrossSellAddedToCart: function (productId, productName) {
        this.fireEvent("CrossSell Added to Cart", `productId=${productId}&productName=${productName}`);
      },

      onCrossSellRemovedFromCart: function (productId, productName) {
        this.fireEvent("CrossSell Removed from Cart", `productId=${productId}&productName=${productName}`);
      },

      onValidCouponApplied: function (coupon) {
        this.fireEvent("Valid Coupon Applied", `couponCode=${coupon}`);
      },

      onInvalidCouponApplied: function (coupon) {
        this.fireEvent("Invalid Coupon Applied", `couponCode=${coupon}`);
      },

    },

    initSteps: function () {
      return new FcSteps(settings.steps);
    },

    enableLoader: function () {
      $(".fc-checkout").block({
        message: null,
        overlayCSS: {
          background: "#FFF",
          opacity: 0.6,
        },
      }).addClass("processing");
    },

    disableLoader: function () {
      $(".fc-checkout").removeClass("processing").unblock();
    },

    isMobile: function () {
      return window.matchMedia("(max-width: 761px)").matches;
    },

    utils: {
      isEqual: function (a, b) {
        // Create arrays of property names
        const aProps = Object.getOwnPropertyNames(a);
        const bProps = Object.getOwnPropertyNames(b);

        // If number of properties is different,
        // objects are not equivalent
        if (aProps.length !== bProps.length) {
          return false;
        }

        for (let i = 0; i < aProps.length; i++) {
          const propName = aProps[i];

          // If values of same property are not equal,
          // objects are not equivalent
          if (a[propName] !== b[propName]) {
            return false;
          }
        }

        // If we made it this far, objects
        // are considered equivalent
        return true;
      },
    },

    variationUtils: {
      findMatchingVariations: function (variations, attributes) {
        const matching = [];
        for (let i = 0; i < variations.length; i++) {
          const variation = variations[i];

          if (main.variationUtils.isMatch(variation.attributes, attributes)) {
            matching.push(variation);
          }
        }
        return matching;
      },

      isMatch: function (variation_attributes, attributes) {
        let match = true;
        for (let attr_name in variation_attributes) {
          if (variation_attributes.hasOwnProperty(attr_name)) {
            const val1 = variation_attributes[attr_name];
            const val2 = attributes[attr_name];
            if (val1 !== undefined && val2 !== undefined && val1.length !== 0 && val2.length !== 0 && val1 !== val2) {
              match = false;
            }
          }
        }
        return match;
      },
    },
  };

  /*
   * Initialization
   */

  const $body = $("body");

  if ($body.hasClass("fc-checkout-enabled")) {
    main.common();

    if ($body.hasClass("fc-checkout-page")) {
      main.pages.checkout.init();
    } else if ($body.hasClass("fc-thank-you-page")) {
      main.pages.thankYou.init();
    }
  }

  if ($body.hasClass("fc-pre-step")) {
    main.pages.preStep.init();
  }

  window.epsilonCheckoutAnalytics = main.analytics;
  window.yournetCheckoutAnalytics = main.analytics;

});

class FcSteps {

  _items = {};
  _itemsArray = [];
  _itemsCount = 0;
  _currentStep = false;
  _touched = [];

  constructor(items) {

    items.forEach(item => {
      if (item.active) {
        this._items[item["path"]] = item;
        this._itemsArray.push({
          step: item["path"],
          ...item,
        });
      }
    });

    this._itemsCount = this._itemsArray.length;

    this._init();

  }

  getItems() {
    return this._items;
  }

  getItemsArray() {
    return this._itemsArray;
  }

  getItemsCount() {
    return this._itemsCount;
  }

  getCurrentStep() {
    return {
      ...this._items[this._currentStep],
      step: this._currentStep,
    };
  }

  getCurrentStepIndex() {
    return this.getStepIndex(this._currentStep);
  }

  isCurrentStepTouched() {
    return this.isStepTouched(this._currentStep);
  }

  getNextStep() {

    const currentIndex = this.getStepIndex(this._currentStep);

    if (currentIndex !== -1 && currentIndex < this._itemsCount - 1) {
      return this._itemsArray[currentIndex + 1];
    }

    return false;

  }

  getStepIndex(stepKey) {
    return this._itemsArray.findIndex(({ step }) => step === stepKey);
  }

  isStepTouched(stepKey) {
    return this._touched.indexOf(stepKey) !== -1;
  }

  setStep(step = false) {

    step = step || this._itemsArray[0].step;

    if (this._items[step] !== undefined || step === "completed") {

      if (this._touched.indexOf(step) === -1) {
        this._touched.push(step);
      }

      this._currentStep = step;
      this._setProgressBar(step);

      // trigger ablyft
      if (window.ablyft) {
        window.ablyft.push({
          eventType: "activatePage",
          pageApiName: `checkout-step-${step}`,
        });
      }
    }

  }

  _init() {
    this._initHtml();
    this._initEventListeners();
  }

  _initHtml() {

    const $holder = $(".fc-progress-bar");

    this._itemsArray.forEach(({ label, step }, i) => {

      const itemHtml = `
        <div class="fc-progress-bar__item" data-step="${step}">
          <div class="fc-progress-bar__label">
           <span class="fc-hidden-mobile-sm">${i + 1}.&nbsp;</span>${label}
          </div>
        </div>`;

      $holder.append(itemHtml);

    });

    $(".fc-progress-bar__line").css("width", 100 - 100 / (this._itemsCount) + "%");

  }

  _initEventListeners() {

    $(window).resize(() => {
      if (this._currentStep) {
        this.setStep(this._currentStep);
      }
    });

    $(".fc-progress-bar__item").click(this._handleStepChoose);

  }

  _handleStepChoose = (e) => {

    const step = $(e.currentTarget).data("step");

    if (step && this._currentStep !== step) {

      const currentIndex = this.getStepIndex(this._currentStep),
        chosenIndex = this.getStepIndex(step);

      if (chosenIndex < currentIndex) {
        $(".fc-progress-bar").trigger("fc-step-choose", [this._items[step]]);
      }

    }

  };

  _setProgressBar(step) {

    const $steps = $(".fc-progress-bar__item:visible"),
      activeClass = "fc-progress-bar__item--active",
      doneClass = "fc-progress-bar__item--done",
      isMobile = window.matchMedia("(max-width: 761px)").matches;

    $steps.removeClass(`${activeClass} ${doneClass}`);

    let progress = 0;

    this._itemsArray.some(({ step: stepKey }, i) => {

      let className = doneClass;
      const $step = $steps.eq(i);

      if (stepKey === step) {
        className = activeClass;
      }

      $step.addClass(className);

      progress += $step.outerWidth();

      if (stepKey === step) {
        if (isMobile) {
          progress -= $step.outerWidth() / 2;
        } else {
          progress -= $step.outerWidth();
        }
      }

      return stepKey === step;

    });

    const $line = $(".fc-progress-bar__line:visible");

    if (progress > $line.outerWidth()) {
      progress = $line.outerWidth();
    }

    $(".fc-progress-bar__line-bar").css({
      width: progress * 100 / $line.outerWidth() + "%",
    });

  }
}
